import React from "react";
import "@/App.css";
import "./i18n";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Header from "@/components/Header";
import HeroSlider from "@/components/HeroSlider";
import PopularDestinations from "@/components/PopularDestinations";
import HowItWorks from "@/components/HowItWorks";
import WhyChooseUs from "@/components/WhyChooseUs";
import CTASection from "@/components/CTASection";
import Footer from "@/components/Footer";
import { Toaster } from "@/components/ui/toaster";

// Schengen Pages
import SchengenVisaPage from "@/pages/SchengenVisaPage";
import ItalyVisaPage from "@/pages/ItalyVisaPage";
import SpainVisaPage from "@/pages/SpainVisaPage";
import FranceVisaPage from "@/pages/FranceVisaPage";
import SwitzerlandVisaPage from "@/pages/SwitzerlandVisaPage";
import DomesticWorkersVisaPage from "@/pages/DomesticWorkersVisaPage";

// USA & UK Pages
import USVisaPage from "@/pages/USVisaPage";
import RegularUSVisaPage from "@/pages/RegularUSVisaPage";
import RenewingUSVisaPage from "@/pages/RenewingUSVisaPage";
import USStudentVisaPage from "@/pages/USStudentVisaPage";
import UKVisaPage from "@/pages/UKVisaPage";
import RegularUKVisaPage from "@/pages/RegularUKVisaPage";
import UKStudentVisaPage from "@/pages/UKStudentVisaPage";

// Other Visas Pages
import JapanVisaPage from "@/pages/JapanVisaPage";
import ChinaVisaPage from "@/pages/ChinaVisaPage";
import SouthAfricaVisaPage from "@/pages/SouthAfricaVisaPage";
import CanadaVisaPage from "@/pages/CanadaVisaPage";
import RussiaVisaPage from "@/pages/RussiaVisaPage";
import CyprusVisaPage from "@/pages/CyprusVisaPage";
import AustraliaVisaPage from "@/pages/AustraliaVisaPage";
import SaudiArabiaVisaPage from "@/pages/SaudiArabiaVisaPage";
import TurkeyVisaPage from "@/pages/TurkeyVisaPage";
import SingaporeVisaPage from "@/pages/SingaporeVisaPage";
import NewZealandVisaPage from "@/pages/NewZealandVisaPage";
import BaliVisaPage from "@/pages/BaliVisaPage";

// UAE Services Pages
import DigitalNomadVisaPage from "@/pages/DigitalNomadVisaPage";
import UAEFreelanceVisaPage from "@/pages/UAEFreelanceVisaPage";
import UAEGoldenVisaPage from "@/pages/UAEGoldenVisaPage";
import UAEBankAccountPage from "@/pages/UAEBankAccountPage";
import UAEBusinessSetupPage from "@/pages/UAEBusinessSetupPage";

// Apply Now Page
import ApplyNowPage from "@/pages/ApplyNowPage";

// About Us Page
import AboutUsPage from "@/pages/AboutUsPage";

// Privacy Policy Page
import PrivacyPolicyPage from "@/pages/PrivacyPolicyPage";

// Contact, Partnership, Careers Pages
import ContactPage from "@/pages/ContactPage";
import PartnershipPage from "@/pages/PartnershipPage";
import CareersPage from "@/pages/CareersPage";

const Home = () => {
  return (
    <div className="min-h-screen">
      <Header />
      <HeroSlider />
      <PopularDestinations />
      <HowItWorks />
      <WhyChooseUs />
      <CTASection />
      <Footer />
    </div>
  );
};

const ScrollToTop = () => {
  const { pathname } = useLocation();
  React.useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
  return null;
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <Routes>
            <Route path="/" element={<Home />} />
            
            {/* Schengen Routes */}
            <Route path="/services/schengen-visa" element={<SchengenVisaPage />} />
            <Route path="/services/urgent-schengen-visa" element={<SchengenVisaPage />} />
            <Route path="/services/italian-visa" element={<ItalyVisaPage />} />
            <Route path="/services/spanish-visa" element={<SpainVisaPage />} />
            <Route path="/services/french-visa" element={<FranceVisaPage />} />
            <Route path="/services/switzerland-visa" element={<SwitzerlandVisaPage />} />
            <Route path="/services/visa-for-domestic-workers" element={<DomesticWorkersVisaPage />} />
            
            {/* USA & UK Routes */}
            <Route path="/services/usa-urgent-visa" element={<USVisaPage />} />
            <Route path="/services/us-visa" element={<RegularUSVisaPage />} />
            <Route path="/services/renewing-us-visa-in-dubai" element={<RenewingUSVisaPage />} />
            <Route path="/services/usa-study-visa" element={<USStudentVisaPage />} />
            <Route path="/services/urgent-uk-visa" element={<UKVisaPage />} />
            <Route path="/services/uk-visa-2" element={<RegularUKVisaPage />} />
            <Route path="/services/uk-student-visa" element={<UKStudentVisaPage />} />
            
            {/* Other Visas Routes */}
            <Route path="/services/japan-visa" element={<JapanVisaPage />} />
            <Route path="/services/china-visa" element={<ChinaVisaPage />} />
            <Route path="/services/visa-to-south-africa" element={<SouthAfricaVisaPage />} />
            <Route path="/services/canada-visa" element={<CanadaVisaPage />} />
            <Route path="/services/russia-visa" element={<RussiaVisaPage />} />
            <Route path="/services/cyprus" element={<CyprusVisaPage />} />
            <Route path="/services/australia-visa" element={<AustraliaVisaPage />} />
            <Route path="/services/saudi-arabia-visa" element={<SaudiArabiaVisaPage />} />
            <Route path="/services/turkey-visa" element={<TurkeyVisaPage />} />
            <Route path="/services/singapore-visa" element={<SingaporeVisaPage />} />
            <Route path="/services/new-zealand-visa" element={<NewZealandVisaPage />} />
            <Route path="/services/visa-to-bali" element={<BaliVisaPage />} />
            
            {/* UAE Services Routes */}
            <Route path="/services/digital-nomad-visa" element={<DigitalNomadVisaPage />} />
            <Route path="/services/uae-freelance-visa" element={<UAEFreelanceVisaPage />} />
            <Route path="/services/uae-golden-visa" element={<UAEGoldenVisaPage />} />
            <Route path="/services/uae-bank-account" element={<UAEBankAccountPage />} />
            <Route path="/services/uae-business-setup" element={<UAEBusinessSetupPage />} />
            
            {/* Apply Now Route */}
            <Route path="/apply" element={<ApplyNowPage />} />
            
            {/* About Us Route */}
            <Route path="/about" element={<AboutUsPage />} />
            
            {/* Privacy Policy Route */}
            <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
            
            {/* Contact, Partnership, Careers Routes */}
            <Route path="/contact" element={<ContactPage />} />
            <Route path="/partnership" element={<PartnershipPage />} />
            <Route path="/careers" element={<CareersPage />} />
          </Routes>
      </BrowserRouter>
      <Toaster />
    </div>
  );
}

export default App;
